<template>
  <div class="home">
    <v-row><h2>Welcome to the Pay Cat Time Sync App</h2></v-row>
    <v-row>
      <span m-t-10 v-if="!$auth.loading && !$auth.isAuthenticated">Please log in to continue</span>
    </v-row>
  </div>
</template>

<script>

export default {
  name: 'Home',
  components: {
  },
  methods: {
    login() {
      this.$auth.loginWithRedirect();
    },
  },
};
</script>

<style scoped>
  .home {
    margin: 20px;
  }
  v-row {
    margin-top: 20px;
  }
</style>
